import Forgot from '@/core/pages/auth/Forgot/Forgot';

export default Forgot;
